export default __webpack_public_path__ + "static/media/china.e8ba2e1b.jpg";